var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyphen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 2,
    viewBox: "0 0 23 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.764922 1.12V0.376H3.90892V1.12H0.764922ZM5.34695 1.12V0.376H8.49095V1.12H5.34695ZM9.92898 1.12V0.376H13.073V1.12H9.92898ZM14.511 1.12V0.376H17.655V1.12H14.511ZM19.093 1.12V0.376H22.237V1.12H19.093Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyphen);
export default __webpack_public_path__ + "static/media/hyphen.fa6a543db7c625c35171203004ff4634.svg";
export { ForwardRef as ReactComponent };